(function () {
  "use strict";
  if (window.tangQuoteCartInstalled) return;
  window.tangQuoteCartInstalled = true;
  var Core = window.TangQuoteCartCore;
  if (!Core) return;

  function readCart() { return Core.read(window.localStorage.getItem(Core.key)); }
  function saveCart(cart) {
    try { window.localStorage.setItem(Core.key, JSON.stringify(cart)); }
    catch (error) { throw new Error("Your browser could not save this quote cart. Please allow site storage or use WhatsApp Us for Quote."); }
    updateBadge(cart);
  }
  function status(element, message, error) {
    if (!element) return;
    element.textContent = message || "";
    element.classList.toggle("is-error", Boolean(error));
  }
  function productStatus(element, message, error) {
    status(element.querySelector("[data-tang-quote-product-status]"), message, error);
  }
  function updateBadge(cart) {
    var total = cart ? Core.count(cart) : 0;
    document.querySelectorAll("[data-tang-quote-link]").forEach(function (link) {
      link.setAttribute("aria-label", "Quote Cart, " + total + " items");
      var badge = link.querySelector("[data-tang-quote-badge]");
      if (badge) {
        badge.hidden = total === 0;
        badge.textContent = total > 99 ? "99+" : String(total);
      }
    });
  }
  function selection(element) {
    var info = element.closest(".product__info-container") || element;
    var fallback = JSON.parse(element.querySelector("[data-tang-quote-default]").textContent);
    var names = JSON.parse(element.querySelector("[data-tang-quote-option-names]").textContent);
    var picker = info.querySelector("variant-radios, variant-selects");
    var variant = fallback;
    if (picker) {
      var selectedOptions;
      if (picker.tagName.toLowerCase() === "variant-radios") {
        selectedOptions = Array.from(picker.querySelectorAll("fieldset")).map(function (field) {
          var radio = field.querySelector('input[type="radio"]:checked');
          return radio ? radio.value : null;
        });
      } else {
        selectedOptions = Array.from(picker.querySelectorAll("select")).map(function (select) { return select.value; });
      }
      var data = picker.querySelector('script[type="application/json"]');
      variant = data ? Core.selected(JSON.parse(data.textContent), selectedOptions) : null;
    }
    if (!variant || !variant.id) throw new Error("Please choose a valid combination of product options.");
    var input = info.querySelector('input[name="quantity"]');
    var options = variant.options || [variant.option1, variant.option2, variant.option3].filter(function (x) { return x != null; });
    var item = {
      productId: element.dataset.productId,
      variantId: String(variant.id),
      title: element.dataset.productTitle,
      path: element.dataset.productPath,
      sku: variant.sku || "",
      quantity: Core.quantity(input ? input.value : 1),
      options: options.map(function (value, index) {
        return { name: names[index] || "Option " + (index + 1), value: String(value) };
      }).filter(function (option) { return !(option.name === "Title" && option.value === "Default Title"); })
    };
    return item;
  }
  function refreshProduct(element, reportError) {
    var direct = element.querySelector("[data-tang-quote-direct]");
    var add = element.querySelector("[data-tang-quote-add]");
    try {
      var item = selection(element);
      direct.href = Core.whatsapp(Core.message({ items: [item], notes: "" }, window.location.origin));
      direct.removeAttribute("aria-disabled");
      add.disabled = false;
      if (reportError) productStatus(element, "", false);
      return item;
    } catch (error) {
      direct.removeAttribute("href");
      direct.setAttribute("aria-disabled", "true");
      add.disabled = true;
      if (reportError) productStatus(element, error.message, true);
      return null;
    }
  }
  function initializeProducts(scope) {
    scope.querySelectorAll("[data-tang-quote-product]").forEach(function (element) {
      if (element.dataset.quoteInitialized) return;
      element.dataset.quoteInitialized = "true";
      var info = element.closest(".product__info-container");
      if (info) {
        info.setAttribute("data-tang-quote-enabled", "");
        var quantity = info.querySelector('input[name="quantity"]');
        if (quantity) quantity.max = String(Core.maxQuantity);
        var refresh = function () { refreshProduct(element, true); };
        info.addEventListener("input", refresh);
        info.addEventListener("change", refresh);
      }
      refreshProduct(element, true);
    });
  }
  function addProduct(element) {
    try {
      var item = selection(element);
      var next = Core.add(readCart(), item);
      saveCart(next);
      productStatus(element, "Added " + item.quantity + " × " + item.title + " to your quote cart.", false);
      element.querySelector("[data-tang-quote-view]").hidden = false;
      if (typeof window.gtag === "function") {
        window.gtag("event", "add_to_quote_cart", {
          send_to: "G-SW9KRJZJ4L",
          item_id: item.variantId,
          quantity: item.quantity
        });
      }
    } catch (error) { productStatus(element, error.message, true); }
  }
  function node(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  }
  function itemRow(item) {
    var row = node("li", "tang-quote-item");
    var info = node("div", "tang-quote-item__info");
    var title = node("a", "tang-quote-item__title", item.title);
    title.href = item.path + "?variant=" + item.variantId;
    info.appendChild(title);
    item.options.forEach(function (option) { info.appendChild(node("p", "", option.name + ": " + option.value)); });
    if (item.sku) info.appendChild(node("p", "", "SKU: " + item.sku));
    var control = node("div", "tang-quote-item__quantity");
    var id = "TangQuoteQty-" + item.variantId;
    var label = node("label", "", "Quantity");
    label.htmlFor = id;
    var input = node("input");
    input.type = "number";
    input.id = id;
    input.min = "1";
    input.max = String(Core.maxQuantity);
    input.step = "1";
    input.value = item.quantity;
    input.dataset.tangQuoteQuantity = item.variantId;
    input.setAttribute("aria-label", "Quantity for " + item.title + " " + item.options.map(function (o) { return o.value; }).join(" / "));
    control.appendChild(label);
    control.appendChild(input);
    var remove = node("button", "tang-quote-item__remove", "Remove");
    remove.type = "button";
    remove.dataset.tangQuoteRemove = item.variantId;
    remove.setAttribute("aria-label", "Remove " + item.title + " " + item.options.map(function (o) { return o.value; }).join(" / "));
    row.appendChild(info);
    row.appendChild(control);
    row.appendChild(remove);
    return row;
  }
  function updateSummary(page, cart) {
    page.querySelector("[data-tang-quote-summary]").textContent =
      cart.items.length + (cart.items.length === 1 ? " product option" : " product options") + " · " + Core.count(cart) + " items";
    var delivery = Core.delivery(cart, window.location.origin);
    page.querySelector("[data-tang-quote-message]").value = delivery.text;
    page.querySelector("[data-tang-quote-long-message]").hidden = !delivery.copyFirst;
    var send = page.querySelector("[data-tang-quote-send]");
    send.href = delivery.href;
    send.textContent = delivery.copyFirst ? "Open WhatsApp — Paste Your Copied List" : "Send Cart for Quotation on WhatsApp";
    page.dataset.copyFirst = delivery.copyFirst ? "true" : "false";
  }
  function renderCart(page) {
    var loading = page.querySelector("[data-tang-quote-loading]");
    var content = page.querySelector("[data-tang-quote-content]");
    var empty = page.querySelector("[data-tang-quote-empty]");
    var clear = page.querySelector("[data-tang-quote-clear]");
    loading.hidden = true;
    try {
      var cart = readCart();
      var hasItems = cart.items.length > 0;
      empty.hidden = hasItems;
      content.hidden = !hasItems;
      clear.hidden = !hasItems;
      var list = page.querySelector("[data-tang-quote-items]");
      list.replaceChildren();
      cart.items.forEach(function (item) { list.appendChild(itemRow(item)); });
      page.querySelector("[data-tang-quote-notes]").value = cart.notes;
      updateSummary(page, cart);
      updateBadge(cart);
    } catch (error) {
      empty.hidden = true;
      content.hidden = true;
      clear.hidden = false;
      status(page.querySelector("[data-tang-quote-cart-status]"), error.message, true);
    }
  }
  function prepareCartMessage(page) {
    var cart = readCart();
    if (!cart.items.length) throw new Error("Your quote cart is empty. Add a product before sending a quotation request.");
    page.querySelectorAll("[data-tang-quote-quantity]").forEach(function (input) {
      cart = Core.setQuantity(cart, input.dataset.tangQuoteQuantity, input.value);
      input.setCustomValidity("");
    });
    cart.notes = page.querySelector("[data-tang-quote-notes]").value;
    saveCart(cart);
    updateSummary(page, cart);
    return cart;
  }
  function initializeCart(page) {
    if (page.dataset.quoteInitialized) return;
    page.dataset.quoteInitialized = "true";
    renderCart(page);
    page.addEventListener("change", function (event) {
      var input = event.target.closest("[data-tang-quote-quantity]");
      if (!input) return;
      try {
        var cart = Core.setQuantity(readCart(), input.dataset.tangQuoteQuantity, input.value);
        saveCart(cart);
        input.setCustomValidity("");
        updateSummary(page, cart);
        status(page.querySelector("[data-tang-quote-cart-status]"), "Quantity updated.", false);
      } catch (error) {
        input.setCustomValidity(error.message);
        input.reportValidity();
        status(page.querySelector("[data-tang-quote-cart-status]"), error.message, true);
      }
    });
    page.querySelector("[data-tang-quote-notes]").addEventListener("input", function (event) {
      try {
        var cart = readCart();
        cart.notes = event.target.value;
        saveCart(cart);
        updateSummary(page, cart);
      } catch (error) { status(page.querySelector("[data-tang-quote-cart-status]"), error.message, true); }
    });
    page.addEventListener("click", async function (event) {
      var target = event.target.closest("button, a");
      if (!target) return;
      var feedback = page.querySelector("[data-tang-quote-cart-status]");
      try {
        if (target.hasAttribute("data-tang-quote-remove")) {
          saveCart(Core.remove(readCart(), target.dataset.tangQuoteRemove));
          renderCart(page);
          status(feedback, "Item removed from your quote cart.", false);
          page.querySelector("[data-tang-quote-heading]").focus();
        } else if (target.hasAttribute("data-tang-quote-clear")) {
          saveCart({ version: 1, items: [], notes: "" });
          renderCart(page);
          status(feedback, "Your quote cart is now empty.", false);
          page.querySelector("[data-tang-quote-heading]").focus();
        } else if (target.hasAttribute("data-tang-quote-copy")) {
          prepareCartMessage(page);
          var text = page.querySelector("[data-tang-quote-message]");
          try {
            if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error("Clipboard unavailable");
            await navigator.clipboard.writeText(text.value);
            status(feedback, "Quote details copied. Open WhatsApp and paste the list if needed.", false);
          } catch (error) {
            text.closest("details").open = true;
            text.focus();
            text.select();
            status(feedback, "Copy the highlighted quote details, then paste them into WhatsApp.", false);
          }
        } else if (target.hasAttribute("data-tang-quote-send")) {
          var invalid = page.querySelector("[data-tang-quote-quantity]:invalid");
          if (invalid) {
            event.preventDefault();
            invalid.reportValidity();
            throw new Error("Please correct the quantity before sending your quote.");
          }
          prepareCartMessage(page);
        }
      } catch (error) {
        if (target.hasAttribute("data-tang-quote-send")) event.preventDefault();
        status(feedback, error.message, true);
      }
    });
  }
  document.addEventListener("submit", function (event) {
    if (!event.target.matches("[data-tang-quote-form]")) return;
    event.preventDefault();
    addProduct(event.target.closest("[data-tang-quote-product]"));
  });
  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("[data-tang-quote-direct]");
    if (!link) return;
    if (!refreshProduct(link.closest("[data-tang-quote-product]"), true)) event.preventDefault();
  });
  function initialize(scope) {
    initializeProducts(scope);
    scope.querySelectorAll("[data-tang-quote-cart]").forEach(initializeCart);
    try { updateBadge(readCart()); } catch (error) { updateBadge(null); }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initialize(document); });
  else initialize(document);
  document.addEventListener("shopify:section:load", function (event) { initialize(event.target); });
  window.addEventListener("storage", function (event) {
    if (event.key !== Core.key && event.key !== null) return;
    initialize(document);
    document.querySelectorAll("[data-tang-quote-cart]").forEach(renderCart);
  });
})();
